<template>
  <div>
    <!-- <div class="adabundle-subheader"><h4>Easy Orientation</h4></div> -->

    <div id="adabundle-easy-orientation-box">

        <div v-for="orientation in easy_orientation" v-show="orientation.status == 1" :id="orientation.id" class="adabundle-action-box adabundle-toggle-box" tabindex="0">
            <div class="adabundle-action-box-content">
                <span class="adabundle-icon"></span>
                <span class="adabundle-title">{{orientation.title}}</span>
            </div>
        </div>
       
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Utility from '../common/Utility';
import  HTTP from "../common/Http";

export default {
  name: "EasyOrientation",
  components: {
  },
  created () {
    this.init()
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'setWidgetOptions') {
        this.widgetOptions = state.widgetOptions;
        // this.init()
      }

      if (mutation.type === 'setWidgetLanguage') {
        this.init();
      }
    });
  },
  mounted(){
     this.logClicks();
  },
  data () {
    return {
      isLoading: false,
      easy_orientation: [] 
    }
  },
  beforeDestroy() {
    this.unsubscribe();
  },
  computed: {
    ...mapState([
      "timeStamp",
      "wid",
      "widgetOptions",
      "t",
    ])
  },
  methods: {
    logClicks(){
      for(const button of this.easy_orientation){
        document.getElementById(button.id).addEventListener("click", (event) => {
            
            this.$store.dispatch('logClicks', { wid:this.wid, label: button.title, debug: this.debug});

            event.preventDefault();
        });
      }
    },
    init(){
        // this.easy_orientation = [
        //     {
        //         id: 'adabundle-action-mute-sounds',
        //         title: 'Mute Sounds',
        //         status: this.widgetOptions.muteSounds
        //     },
        //     {
        //         id: 'adabundle-action-hide-images',
        //         title: 'Hide Images',
        //         status: this.widgetOptions.hideImages
        //     },
        //     {
        //         id: 'adabundle-action-virtual-keyboard',
        //         title: 'Virtual Keyboard',
        //         status: this.widgetOptions.virtualKeyboard
        //     },
        //     {
        //         id: 'adabundle-action-reading-guide',
        //         title: 'Reading Guide',
        //         status: this.widgetOptions.readingGuide
        //     },
        //     {
        //         id: 'adabundle-action-stop-animations',
        //         title: 'Stop Animations',
        //         status: this.widgetOptions.stopAnimations
        //     },
        //     {
        //         id: 'adabundle-action-reading-mask',
        //         title: 'Reading Mask',
        //         status: this.widgetOptions.readingMask
        //     },
        //     {
        //         id: 'adabundle-action-highlight-hover',
        //         title: 'Highlight Hover',
        //         status: this.widgetOptions.highlightHover
        //     },
        //     {
        //         id: 'adabundle-action-highlight-focus',
        //         title: 'Highlight Focus',
        //         status: this.widgetOptions.highlightFocus
        //     },
        //     {
        //         id: 'adabundle-action-big-black-cursor',
        //         title: 'Big Black Cursor',
        //         status: this.widgetOptions.bigBlackCursor
        //     },
        //     {
        //         id: 'adabundle-action-big-white-cursor',
        //         title: 'Big White Cursor',
        //         status: this.widgetOptions.bigWhiteCursor
        //     },
        //     {
        //         id: 'adabundle-action-keyboard-navigation',
        //         title: 'Navigation Keys',
        //         status: this.widgetOptions.keyboardNavigation
        //     },
        //     {
        //         id: 'adabundle-action-text-to-speech',
        //         title: 'Text to Speech',
        //         status: this.widgetOptions.textToSpeech
        //     }
        // ];
        

        const t = this.t;

        this.easy_orientation = [
            {
                id: 'adabundle-action-mute-sounds',
                title: t.mute_sound.text,
                status: this.widgetOptions.muteSounds
            },
            {
                id: 'adabundle-action-hide-images',
                title: t.hide_image.text,
                status: this.widgetOptions.hideImages
            },
            {
                id: 'adabundle-action-virtual-keyboard',
                title: t.virtual_keyboard.text,
                status: this.widgetOptions.virtualKeyboard
            },
            {
                id: 'adabundle-action-reading-guide',
                title: t.reading_guide.text,
                status: this.widgetOptions.readingGuide
            },
            {
                id: 'adabundle-action-stop-animations',
                title: t.stop_animation.text,
                status: this.widgetOptions.stopAnimations
            },
            {
                id: 'adabundle-action-reading-mask',
                title: t.reading_mask.text,
                status: this.widgetOptions.readingMask
            },
            {
                id: 'adabundle-action-highlight-hover',
                title: t.highlight_hover.text,
                status: this.widgetOptions.highlightHover
            },
            {
                id: 'adabundle-action-highlight-focus',
                title: t.highlight_focus.text,
                status: this.widgetOptions.highlightFocus
            },
            {
                id: 'adabundle-action-big-black-cursor',
                title: t.black_cursor.text,
                status: this.widgetOptions.bigBlackCursor
            },
            {
                id: 'adabundle-action-big-white-cursor',
                title: t.white_cursor.text,
                status: this.widgetOptions.bigWhiteCursor
            },
            {
                id: 'adabundle-action-keyboard-navigation',
                title: t.navigation_keys.text,
                status: this.widgetOptions.keyboardNavigation
            },
            {
                id: 'adabundle-action-text-to-speech',
                title: t.tts.text,
                status: this.widgetOptions.textToSpeech
            }
        ];
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>
